import { useLocation } from "react-router-dom";
import { JsonLd } from "./json-ld";
import { useOfferings } from "../offerings/use-offerings";
import { buildStructuredDataForPath } from "../seo/site-seo";

export function SiteStructuredData() {
  const { pathname } = useLocation();
  const { offerings } = useOfferings();
  const data = buildStructuredDataForPath(pathname, offerings);

  if (data.length === 0) {
    return null;
  }

  return <JsonLd data={data} />;
}
